/**
 * External dependencies.
 */
import { useState } from "react";
import Image from "next/image";
import { Trans } from "@lingui/macro";

/**
 * Internal dependencies
 */
import Link from "components/link/link";
import { getSlug, getStrapiMediaArr, useThemeString } from "utils";

interface ThemeListingItemProp {
  app?: boolean;
  theme: {
    slug_overwrite?: string;
    slug: string;
    name?: string;
    price?: string;
    image?: string;
    colors?: string[];
    Variants: any[];
  };
  variant?: any;
}

const ThemeListingItem: React.FC<ThemeListingItemProp> = ({
  theme,
  app,
  variant,
}) => {
  const themeString = useThemeString();
  const hash =
    (variant && variant.Title === "Default") ||
    (variant && variant.Title === theme.name)
      ? ""
      : `/#${variant && variant.Title.toLowerCase()}`;
  const url = `/${app ? "apps" : themeString}/${getSlug(theme)}${
    !app ? hash : ""
  }`;
  return (
    <div className="theme-listing__item">
      <Link href={url} className="theme-listing__image">
        <div className="theme-listing__image-inner">
          {variant && variant.Images && (
            <Image
              src={getStrapiMediaArr(variant.Images.data[0])}
              width={520}
              height={661}
              alt={theme.name || ""}
            />
          )}
          {!variant && theme.image && (
            <Image
              src={theme.image}
              width={520}
              height={661}
              alt={theme.name || ""}
            />
          )}
          <div className="theme-listing__image-overlay">
            <span>
              <Trans>Preview</Trans>{" "}
              {app ? <Trans>app</Trans> : <Trans>theme</Trans>}
              <svg
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="btn-link__arrow"
              >
                <path
                  d="M12.0328 3.54175L11.1573 4.41565L14.622 7.88029L-1.89644e-07 7.88029L-2.43828e-07 9.11987L14.622 9.11987L11.1511 12.5783L12.0328 13.4584L17 8.50008L12.0328 3.54175Z"
                  fill="#fff"
                />
              </svg>
            </span>
          </div>
        </div>
      </Link>
      {/* <div className="theme-listing__variants">
        {theme.colors &&
          theme.colors.map((color, index) => (
            <div
              key={index}
              className="theme-listing__variant"
              style={{ backgroundColor: color }}
            ></div>
          ))}
      </div> */}
      <Link href={url}>
        <div className="theme-listing__head">
          <p className="theme-listing__head-title">
            {variant ? (
              <>
                {variant.Title}
                <span>{theme.name}</span>
              </>
            ) : (
              theme.name
            )}
          </p>
          <p>{theme.price}</p>
        </div>
      </Link>
    </div>
  );
};

export default ThemeListingItem;
